

export default class CertificadoResponse {
    constructor(
        public statusCode?: number,
        public message?: string, 
        public base64?: string,
        public detail?: string
    ) {}
} 

class header {
    constructor(
        public code?:  number,
        public lambdaVersion?: string,
        public lambdaAlias?: string,
        public lambdaName?: string,
        public message?: string,
        public detail?: string,
        public success?: boolean,
    ) {}
}
export { header ,CertificadoResponse}